// extracted by mini-css-extract-plugin
export default {"principles":"Principles_principles__U4uwq"};